<section>
  <div class="row">
    <form novalidate [formGroup]="formInvoicingCutoff" class="container-style" errorTailor>
      <div class="ps-2 pe-2 ">
        <div class="row pt-1">
          <div class="col">
            <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
              [width]="'6rem'" (onClick)="goToBack($event)" [severity]="null"></app-custom-button>
          </div>
          <div class="col d-flex justify-content-sm-center justify-content-end align-items-center align-items-center">
            <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
          </div>

          <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
            <app-custom-chip class="me-1" *ngIf="previewInvoicingCutoff"
              [label]="'Corte: ' + invoicingCutoffContract.consecutive" />
            <app-custom-button [title]="titlePreviewInvoicingCutoff" [severity]="'contrast'"
              [icon]="iconPreviewInvoicingCutoff" (onClick)="openPreviewInvoicingCutoff()"></app-custom-button>
            <app-custom-button *ngIf="previewInvoicingCutoff" [title]="'Exportar excel'" [severity]="'contrast'"
              [icon]="'pi pi-file-excel'" (onClick)="exporterDetailsPreviewPrint()"></app-custom-button>
            <app-custom-button *ngIf="previewInvoicingCutoff" [title]="'Imprimir'" [severity]="'contrast'"
              [icon]="'pi pi-print'" (onClick)="printPreinvoicing()"></app-custom-button>
            <app-custom-button [hidden]="previewInvoicingCutoff" [title]="'Eliminar'" [severity]="'contrast'"
              [icon]="'pi pi-trash'" (onClick)="deleteInvoicingCutoff()"></app-custom-button>

            <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
              [severity]="'success'" [variant]="undefined" (onClick)="createNewInvoicingCutoff(0)"></app-custom-button>
          </div>
          <hr class="my-1">
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="invoicingCutoffContract.userNameCreate"
              [createDate]="invoicingCutoffContract.createDate"
              [userNameUpdate]="invoicingCutoffContract.userNameUpdate"
              [updateDate]="invoicingCutoffContract.updateDate"
              [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
        <div class="col-lg-12 col-12" [hidden]="previewInvoicingCutoff">
          <div>
            <div class="field-block-by" *ngIf="visibleBlock">
              <span><b class="text-danger">Bloqueado por:</b><b class="ms-1">{{userNameBlock}}</b></span>
            </div>
            <div class="row">
              <div class="col field-branch">
                <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranch"
                  [required]="true" [recovery]="true" (onChangeSelect)="getBranch($event, true)">
                </app-custom-select>
              </div>
              <div class="col field-class">
                <app-custom-select formControlName="invoicingCutoffClass" [labelText]="'Clase Corte'"
                  [list]="listInvoicingCutoffClass" [required]="true" [recovery]="true"
                  (onChangeSelect)="createNewInvoicingCutoff(0, $event)">
                </app-custom-select>
              </div>
              <div class="col field-consecutive">
                <app-custom-input-number formControlName="consecutive" [labelText]="'Número'" [required]="true"
                  [recovery]="true" (onChangeNumber)="changeConsecutive($event)"></app-custom-input-number>
              </div>
              <div class="col field-enterprise">
                <app-custom-select formControlName="enterpriseId" [labelText]="'Empresa'" [list]="listEnterprise"
                  [required]="true" (onChangeSelect)="getEnterprise($event)"></app-custom-select>
              </div>
              <div class="col field-invoicing-cutoff-type" *ngIf="swServicesFullSeparately">
                <app-custom-select formControlName="invoicingCutoffTypeId" [labelText]="'Tipo Corte'"
                  [list]="listInvoicingCutoffType" [required]="true"></app-custom-select>
              </div>
              <div class="col field-date-cutoff">
                <app-custom-datepicker formControlName="dateCutoff" [labelText]="'Fecha Corte'"
                  [required]="true"></app-custom-datepicker>
              </div>
              <div class="col field-state">
                <app-custom-tag [label]="'Estado'" [value]="invoicingCutoffStateString"
                  [severity]="invoicingCutoffContract.invoicingCutoffStateId === 1 ? 'danger' : ''">
                </app-custom-tag>
              </div>
              <div class="col field-state-buttons d-flex align-items-end gap-1 mt-1">
                <app-custom-modal #preInvoicingModal [label]="'Prefacturación'" [header]="'Prefacturación'"
                  [children]="preInvoicingComponent" [inputs$]="inputsForPreInvoicingModal$" [closable]="false"
                  (params)="updateInvoicingCutoff($event)" hidden></app-custom-modal>
                <app-custom-button [id]="'btnPreInvoicingModal'" [title]="'Prefacturación'"
                  [label]="preinvoicingCutoffStateString" [width]="'5rem'" [severity]="'primary'"
                  [disabled]="!disabledState" (onClick)="openPreInvoicingModal()">
                </app-custom-button>
                <app-custom-button [title]="'Suspender'" [label]="'Suspender'" [disabled]="disabledSuspend"
                  [hidden]="hiddenSuspendBtn" (onClick)="suspendInvoicingCutoff()"></app-custom-button>
                <app-custom-modal #invoicingConceptModal [label]="'Selección de Conceptos a facturar'"
                  [header]="'Seleccionar Conceptos a facturar'" [children]="invoicingConceptSelectionComponent"
                  [inputs$]="inputsForInvoicingConceptModal$" [output$]="outputInvoicingConcept$"
                  (selectedItems)="partialInvoicing($event)" hidden>
                </app-custom-modal>
                <app-custom-modal #invoicingModal [label]="'Facturar'" [header]="'Facturar'"
                  [children]="invoicingComponent" [inputs$]="inputsForPreInvoicingModal$" [closable]="false"
                  [width]="'40rem'" (params)="updateInvoicingCutoff($event)" hidden></app-custom-modal>
                <app-custom-button [id]="'btnInvoicingModal'" [title]="'Facturar'" [label]="'Facturar'" [width]="'5rem'"
                  [severity]="'success'" [disabled]="disabledInvoice" (onClick)="openInvoicingModal()">
                </app-custom-button>
              </div>
            </div>
            <div class="row">
              <div class="col field-observation">
                <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [rows]="1"
                  [autoResize]="false" [maxLength]="250"></app-custom-textarea>
              </div>
              <div class="field-save d-flex align-items-end mt-1">
                <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [disabled]="disabledForm"
                  (onClick)="send()"></app-custom-button>
              </div>
              <div class="field-add-cost-center d-flex align-items-end mt-1">
                <app-custom-button [id]="'btnInvoicingCutoffCostCenter'" [title]="'Agregar C.Costos'"
                  [label]="'Agregar C.Costos'" [width]="'9rem'" [icon]="'pi pi-plus-circle'"
                  [disabled]="disabledSelectCostCenter" (onClick)="openSelectCostCenterModal()">
                </app-custom-button>
                <app-custom-modal #selectCostCenter [label]="'Selección de Centros de Costos'"
                  [header]="'Seleccionar Centros de Costos'" [children]="componentTableSelection"
                  [inputs$]="inputsForCostCenterModal$" [output$]="output$" (selectedItems)="createDetail($event)"
                  hidden>
                </app-custom-modal>
              </div>
              <div class="field-cost-center-with-alerts d-flex align-items-end mt-1" *ngIf="costCenterWithAlerts">
                <app-custom-button [title]="'Eliminar C.Costos con Alertas'" [label]="'Eliminar C.Costos con Alertas'"
                  [severity]="'danger'" [width]="'12.5rem'"
                  (onClick)="deleteCostCentersWithAlerts()"></app-custom-button>
              </div>
              <div class="col"></div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="previewInvoicingCutoff" class="preview-invoicing-cutoff">
        <div id="filters" class="row justify-content-between mb-2">
          <div class="col-12 col-md-10 gap-2">
            <div class="row">
              <div class="custom-container col-lg-2 col-md-3 col-sm-6 col-12">
                <app-custom-autocomplete [labelText]="'Cliente'" [list]="listClients" [formControl]="client"
                  (onChangeSelect)="getClient($event)">
                </app-custom-autocomplete>
              </div>
              <div class="custom-container col-lg-2 col-md-3 col-sm-6 col-12">
                <app-custom-autocomplete [labelText]="'C.Costos'" [list]="filteredCostCenters"
                  [formControl]="costCenter" (onChangeSelect)="getCostCenter($event)">
                </app-custom-autocomplete>
              </div>
              <div class="custom-container col-lg-2 col-md-3 col-sm-6 col-12">
                <app-custom-select [labelText]="'Tipo C.Costos'" [list]="listCostCenterTypes" [showClear]="true"
                  [formControl]="costCenterType" (onChangeSelect)="getCostCenterTypes($event)"></app-custom-select>
              </div>
              <div class="custom-container col-lg-1 col-md-2 col-sm-3 col-4 d-flex align-items-end">
                <app-custom-button [title]="'Eliminar filtros'" [severity]="'secondary'" [icon]="'pi pi-filter-slash'"
                  (onClick)="clearFilters()"></app-custom-button>
              </div>
            </div>
          </div>
          <div id="orderBy" class="col-12 col-md-2 gap-2">
            <div class="row">
              <div class="custom-container col-lg-7 col-md-6 col-sm-6 col-12">
                <app-custom-select [labelText]="'Ordenar'" [list]="listOrder" [formControl]="order"
                  (onChangeSelect)="changeOrderBy($event)"></app-custom-select>
              </div>
              <div class="custom-container col-lg-5 col-md-6 col-sm-6 col-12">
                <app-custom-select [labelText]="'Formato'" [list]="listFormatType" [formControl]="format"
                  (onChangeSelect)="getFormatType($event)"></app-custom-select>
              </div>
            </div>
          </div>
          <hr class="my-1">
        </div>
        <app-preview-pre-invoicing id="print-preview-pre-invoicing" *ngIf="previewInvoicingCutoff"
          [companyId]="companyId" [formatModel]="formatModel" [preinvoicingPrintModel]="preinvoicingPrintModel"
          [exporterDetailsPreview]="exporterDetailsPreview" [editFormat]="false" [isGeneralFormat]="formatType"
          [changeOrder]="changeOrder" [filtersPreview]="filtersPreview" (finishLoadingPrint)="visiblePreview($event)">
        </app-preview-pre-invoicing>
      </div>
    </form>

    <div [hidden]="previewInvoicingCutoff" [ngClass]="{ 'mt-2 container-style': quantityDetails > 0 }">
      <p class="quantity-details" [hidden]="previewInvoicingCutoff || quantityDetails === 0">
        {{quantityDetails}} centros de costos agregado(s) de 500 permitidos.</p>

      <app-invoicing-cutoff-detail #invoicingCutoffDetailComponent [visibleFilters]="visibleListDetail"
        [invoicingCutoffModel]="invoicingCutoffContract" [updateInvoicingCutoffListDetail]="updateListDetail"
        [rowsEditable]="disabledDetail" [disabledSelectCostCenter]="disabledSelectCostCenter"
        (quantityDetails)="getQuantityDetails($event)" (quantityCostCenterTypeThird)="onQuantityThirdChange($event)"
        (thereIsCostCenterWithAlerts)="thereIsCostCenterWithAlerts()">
      </app-invoicing-cutoff-detail>
    </div>
  </div>
</section>